import type PlanningSupplyAlternative from 'volta/models/planning-supply-alternative';

export const netNeedFor = (items: PlanningSupplyAlternative[] = []): number => {
  return items.reduce((sum, alt) => sum + (alt.priority >= 0 ? alt.reorderQty : 0), 0);
};

export const hasSupplyAlternatives = (
  items: PlanningSupplyAlternative[] = []
): boolean => {
  return items.some((alt) => alt.priority > 0);
};

export const groupSupplyAlternatives = (
  items: PlanningSupplyAlternative[] = []
): PlanningSupplyAlternative[][] => {
  const positivePriorityProposals: PlanningSupplyAlternative[] = [];
  const otherProposals: PlanningSupplyAlternative[] = [];

  items.forEach((proposal) => {
    if (proposal.priority > 0) {
      positivePriorityProposals.push(proposal);
    } else {
      otherProposals.push(proposal);
    }
  });

  return [positivePriorityProposals, otherProposals].filter((section) => section.length > 0);
};
